<div class="wizard-step-content">
  <h3 class="mb-4">
    <i class="fa fa-credit-card text-primary me-2"></i>
    {{ 'eventWizard.payment.title' | translate }}
  </h3>
  <p class="text-muted mb-6">{{ 'eventWizard.payment.subtitle' | translate }}</p>

  @if (!event) {
    <div class="alert alert-warning">
      <i class="fa fa-exclamation-triangle me-2"></i>
      {{ 'eventWizard.payment.completeBasicFirst' | translate }}
    </div>
  } @else if (!canConfigurePayment) {
    <div class="notice d-flex bg-light-danger rounded border-danger border border-dashed p-6">
      <i class="fa fa-exclamation-triangle text-danger fs-2 me-4"></i>
      <div class="d-flex flex-stack flex-grow-1">
        <div class="fw-semibold">
          <h4 class="text-danger fw-bold">{{ 'eventWizard.payment.stripeNotConnected' | translate }}</h4>
          <div class="fs-6 text-gray-700">
            {{ 'eventWizard.payment.stripeNotConnectedDesc' | translate }}
          </div>
        </div>
      </div>
    </div>

    <div class="text-center py-10 mt-6">
      <i class="fab fa-stripe fs-3x text-muted mb-4 d-block opacity-50"></i>
      <h5 class="text-muted mb-2">{{ 'eventWizard.payment.paymentFeaturesUnavailable' | translate }}</h5>
      <p class="text-muted mb-4">{{ 'eventWizard.payment.skipAndConfigureLater' | translate }}</p>
    </div>
  } @else {
    <!-- Custom Payment Notice -->
    @if (isCustomPaymentEnabled && !isStripeConnected) {
      <div class="notice d-flex bg-light-info rounded border-info border border-dashed p-6 mb-6">
        <i class="fa fa-info-circle text-info fs-2 me-4"></i>
        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-semibold">
            <h4 class="text-gray-900 fw-bold">{{ 'eventWizard.payment.customPaymentActive' | translate }}</h4>
            <div class="fs-6 text-gray-700">
              {{ 'eventWizard.payment.customPaymentActiveDesc' | translate }}
            </div>
          </div>
        </div>
      </div>
    }
    <div class="row">
      <!-- Payment Enabled Toggle -->
      <div class="col-md-6 mb-6">
        <div class="card">
          <div class="card-body">
            <label class="form-label fw-semibold mb-3">{{ 'eventWizard.payment.requirePayment' | translate }}</label>
            <div class="form-check form-switch form-check-custom form-check-solid">
              <input
                class="form-check-input"
                type="checkbox"
                [checked]="event.payment_enabled"
                [disabled]="saving"
                (change)="togglePaymentEnabled($event)"
              />
              <label class="form-check-label fw-semibold text-gray-600 ms-3">
                {{ event.payment_enabled ? ('eventWizard.payment.enabled' | translate) : ('eventWizard.payment.disabled' | translate) }}
              </label>
            </div>
            <div class="text-muted fs-7 mt-2">
              {{ 'eventWizard.payment.whenEnabledDesc' | translate }}
            </div>
          </div>
        </div>
      </div>

      <!-- Payment Timing -->
      <div class="col-md-6 mb-6">
        <div class="card" [class.opacity-50]="!event.payment_enabled">
          <div class="card-body">
            <label class="form-label fw-semibold mb-3">{{ 'eventWizard.payment.paymentTiming' | translate }}</label>
            <div class="d-flex flex-column gap-3">
              <label class="form-check form-check-custom form-check-solid" [class.opacity-50]="!isStripeConnected">
                <input
                  class="form-check-input"
                  type="radio"
                  name="paymentTiming"
                  value="immediate"
                  [checked]="event.payment_timing === 'immediate'"
                  [disabled]="!event.payment_enabled || saving || !isStripeConnected"
                  (change)="setPaymentTiming('immediate')"
                />
                <span class="form-check-label d-flex flex-column ms-3">
                  <span class="fw-bold text-gray-800">{{ 'eventWizard.payment.immediatePayment' | translate }}</span>
                  <span class="text-muted fs-7">{{ 'eventWizard.payment.immediatePaymentDesc' | translate }}</span>
                  @if (!isStripeConnected) {
                    <span class="text-warning fs-7">{{ 'eventWizard.payment.requiresStripe' | translate }}</span>
                  }
                </span>
              </label>
              <label class="form-check form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="radio"
                  name="paymentTiming"
                  value="pay_later"
                  [checked]="event.payment_timing === 'pay_later'"
                  [disabled]="!event.payment_enabled || saving"
                  (change)="setPaymentTiming('pay_later')"
                />
                <span class="form-check-label d-flex flex-column ms-3">
                  <span class="fw-bold text-gray-800">{{ 'eventWizard.payment.payLater' | translate }}</span>
                  <span class="text-muted fs-7">{{ 'eventWizard.payment.payLaterDesc' | translate }}</span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    @if (event.payment_enabled) {
      <div class="alert alert-light-success border border-success border-dashed mt-4">
        <div class="d-flex align-items-center">
          <i class="fa fa-check-circle text-success fs-2 me-3"></i>
          <div>
            <strong>{{ 'eventWizard.payment.paymentsEnabled' | translate }}</strong>
            <div class="text-muted">
              {{ event.payment_timing === 'immediate' ? ('eventWizard.payment.participantsPayImmediately' | translate) : ('eventWizard.payment.participantsPayLater' | translate) }}
            </div>
          </div>
        </div>
      </div>
    } @else {
      <div class="alert alert-light-info border border-info border-dashed mt-4">
        <div class="d-flex align-items-center">
          <i class="fa fa-info-circle text-info fs-2 me-3"></i>
          <div>
            <strong>{{ 'eventWizard.payment.paymentsDisabled' | translate }}</strong>
            <div class="text-muted">
              {{ 'eventWizard.payment.registrationsFree' | translate }}
            </div>
          </div>
        </div>
      </div>
    }
  }
</div>
